module.exports = __webpack_public_path__ + "img/Heritage Bank Plc.76345ed2.png";